const doc = [({"da":({"js":({"admin":({"users":({"edit":({"add_new_user":"Tilføj ny bruger", "edit_user":"Rediger bruger: %{name}", "the_user_was_saved":"Brugeren blev gemt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;